import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

import {
  _fetchClientAllAnnouncementList,
  _updateClientNewAnnouncement,
} from "@/services/announcement";
import { handleAPICatch } from "@/utilities/utils";

import { updateUser } from "./clientprofile";

const initialState = {
  showViewMoreAnnuouncementModal: false,
  showUpdateLoginAnnuouncementModal: false,
  isLoading: false,
  clientAnnouncements: [],
  clickViewMoreAnnouncementId: [],
  pagination: {
    currentPage: 1,
    totalPage: 1,
    isLastPage: false,
  },
  filters: {
    search: "",
  },
  totalCount: 0,
  selectedAll: false,
};

//Fetch all annoucement listing..
export const fetchClientAllAnnouncementListData = createAsyncThunk(
  "clientUsers/fetchClientAllAnnouncementListData",
  async (data, { dispatch, getState }) => {
    const clientAnnouncements = getState().clientAnnouncement;
    let paginationData = clientAnnouncements.pagination;
    if (paginationData.isLastPage) {
      return dispatch(setClientAllAnnouncementListLoading(false));
    }

    const _data = {
      page: paginationData.currentPage,
    };

    const response = _fetchClientAllAnnouncementList(_data);
    response
      .then((res) => {
        const {
          data: { announcement_list, meta },
        } = res;
        const { currentPage, lastPage, isLastPage, total: totalCount } = meta;
        let data = [];
        announcement_list.map((item) => {
          data.push({
            announcement_id: item.id,
            announcement_title: item.title,
            announcement_message: item.message,
            announcement_ref_no: item.ref_no,
            created_at: item.created_at,
          });
        });

        dispatch(
          updatePagination({
            currentPage: currentPage + 1,
            totalPage: lastPage,
            isLastPage: isLastPage,
          }),
        );
        let prevList =
          currentPage === 1
            ? []
            : _.uniq(getState().clientAnnouncement.clientAnnouncements);
        let first_client_announcement_id =
          data?.length > 0 ? data[0]?.announcement_id : null;
        if (
          prevList.length > 0 &&
          prevList.find(
            (item) => item.announcement_id === first_client_announcement_id,
          ) !== undefined
        ) {
          //
        } else {
          dispatch(updateClientAllAnnouncementList([...prevList, ...data]));
        }
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        dispatch(setClientAllAnnouncementListLoading(false));
      });
  },
);

export const updateClientNewAnnounmentData = createAsyncThunk(
  "clientUsers/updateClientNewAnnounmentData",
  async (data, { dispatch }) => {
    let response = _updateClientNewAnnouncement(data);
    response
      .then((res) => {
        dispatch(updateUser({ announcement_message: "" }));
      })
      .catch((error) => {
        handleAPICatch(error);
      })
      .finally(() => {
        // setIsSubmitting(false);
      });
  },
);

const clientAnnouncementSlice = createSlice({
  name: "clientAnnouncement",
  initialState,
  reducers: {
    updateClientAllAnnouncementList: (state, action) => {
      state.clientAnnouncements = action.payload;
    },
    updateClickAnnouncementId: (state, action) => {
      state.clickViewMoreAnnouncementId = action.payload;
    },
    setClientAllAnnouncementListLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    updatePagination: (state, action) => {
      state.pagination = action.payload;
    },
    toggleViewMoreAnnuouncementModal: (state, action) => {
      state.showViewMoreAnnuouncementModal = action.payload;
    },
    toggleUpdateLoginAnnuouncementModal: (state, action) => {
      state.showUpdateLoginAnnuouncementModal = action.payload;
    },
  },
});

export const {
  updateClientAllAnnouncementList,
  updateClickAnnouncementId,
  setClientAllAnnouncementListLoading,
  toggleViewMoreAnnuouncementModal,
  updatePagination,
  toggleUpdateLoginAnnuouncementModal,
} = clientAnnouncementSlice.actions;

export default clientAnnouncementSlice.reducer;
